import React from 'react';
import { useNavigate } from 'react-router-dom';
import headerImage from '../../assets/header.jpg';
import './SessionExpired.css';

const SessionExpired = () => {
  const navigate = useNavigate();

  const handleSignUp = () => {
    // Navigate to the sign-up page or home page
    navigate('/');
  };

  return (
    <div className="session-expired-page">
      <img src={headerImage} alt="Header" className="header-image" />
      <h1>LeapFrog Lab Registration</h1>
      <h2>Session Expired!</h2>
      <div className="expiration-text">
        <p>
          All data you may have entered has been completely removed from our
          database.
        </p>
        <p>
          We thank you for your time, and respect your privacy - you will not be
          contacted by LeapFrog representatives if no registration data has been
          entered.
        </p>
        <p>
          If you would like to start over, please click the 'SignUp' button.
        </p>
      </div>
      <div className="button-group">
        <button className="sign-up-button" onClick={handleSignUp}>
          Sign Up
        </button>
      </div>
      <br />
      <br />
      <br />
      <footer>
        <a
          href="https://www.leapfrog.com/en-us/legal/privacy"
          className="privacy-link"
        >
          Privacy Policy
        </a>
        <div className="copyright">
          Copyright © 2001 - 2024 LeapFrog Enterprises, Inc. All rights
          reserved.
        </div>
      </footer>
    </div>
  );
};

export default SessionExpired;
